import { render, staticRenderFns } from "./Report30per.vue?vue&type=template&id=0a04dc5a&scoped=true"
import script from "./Report30per.vue?vue&type=script&lang=js"
export * from "./Report30per.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a04dc5a",
  null
  
)

export default component.exports